<template>
  <div style="position: relative; width: 100%; height: 100%;">
    <Line :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'
import { Line } from 'vue-chartjs'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

export default {
  name: 'LineChart',
  components: { Line },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false // Oculta legenda padrão para visual mais limpo
          },
          tooltip: {
            backgroundColor: '#0f172a',
            padding: 12,
            cornerRadius: 10,
            titleFont: { family: 'Inter', size: 12, weight: '600' },
            bodyFont: { family: 'Inter', size: 13 },
            displayColors: false,
            callbacks: {
              label: function (context) {
                const value = context.parsed.y || 0
                return 'Arrecadado: R$ ' + value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
              }
            }
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              font: { family: 'Inter', size: 11 },
              color: '#94a3b8'
            }
          },
          y: {
            grid: {
              color: '#f1f5f9' 
            },
            border: {
              dash: [4, 4] // Linha pontilhada suave no eixo Y
            },
            ticks: {
              font: { family: 'Inter', size: 11 },
              color: '#94a3b8',
              callback: (value) => 'R$ ' + value
            }
          }
        },
        elements: {
          line: {
            tension: 0.4 // Deixa a linha curvada/suave
          },
          point: {
            radius: 3,
            hoverRadius: 6,
            backgroundColor: '#561569',
            borderColor: '#ffffff',
            borderWidth: 2
          }
        }
      }
    }
  }
}
</script>